var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-callback" },
    [
      _c(
        "v-container",
        { attrs: { "fill-height": "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "4" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "pa-6", attrs: { elevation: "8" } },
                    [
                      _c("v-card-text", { staticClass: "text-center" }, [
                        _c(
                          "div",
                          { staticClass: "mb-4" },
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                size: 60,
                                width: 6,
                                color: "primary",
                                indeterminate: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c("h2", { staticClass: "headline mb-3" }, [
                          _vm._v(_vm._s(_vm.$t("auth.processing")))
                        ]),
                        _c("p", { staticClass: "body-1 grey--text" }, [
                          _vm._v(_vm._s(_vm.$t("auth.processingMessage")))
                        ]),
                        _vm.error
                          ? _c(
                              "div",
                              { staticClass: "mt-4" },
                              [
                                _c(
                                  "v-alert",
                                  {
                                    attrs: {
                                      type: "error",
                                      dense: "",
                                      outlined: ""
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.error) + " ")]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mt-3",
                                    attrs: {
                                      color: "primary",
                                      loading: _vm.retrying
                                    },
                                    on: { click: _vm.retryAuthentication }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("auth.retry")) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }